import apiCall from '../../index'

const apiService = '/api-erpunigas/api/v1/portal/normativa_tramite'
const authorization = 'Authorization'
const tipoToken = 'Bearer'

const service = {
  findById(params) {
    const query = `?idTramiteOrientacion=${params.idTramiteOrientacion}`
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  create(model) {
    const formData = new FormData()
    formData.append('titulo', model.titulo)
    formData.append('sumisa', model.sumisa)
    formData.append('idTramiteOrientacion', model.idTramiteOrientacion)
    formData.append('orden', model.orden)
    if (model.archivo !== null) formData.append('archivo', model.archivo)
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .post(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  update(model) {
    const formData = new FormData()
    formData.append('idNormativaTramite', model.idNormativaTramite)
    formData.append('titulo', model.titulo)
    formData.append('sumisa', model.sumisa)
    formData.append('idTramiteOrientacion', model.idTramiteOrientacion)
    formData.append('orden', model.orden)
    if (model.archivo !== null) formData.append('archivo', model.archivo)
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .put(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  delete(params) {
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .delete(`${apiService}/${params.id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
